import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { authApi } from "../api/auth";
import { ApiError } from "../api/client";
import "./LoginView.css";

export default function VerifyEmailView() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState<"checking" | "ok" | "error">("checking");
  const [error, setError] = useState<string | null>(null);
  const ran = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (ran.current) return; // StrictMode double-invoke would burn the single-use token
    ran.current = true;
    if (!token) {
      setStatus("error");
      setError("Missing verification token.");
      return;
    }
    authApi
      .verifyEmail(token)
      .then(() => {
        setStatus("ok");
        setTimeout(() => navigate("/", { replace: true }), 1500);
      })
      .catch((err) => {
        setStatus("error");
        setError(err instanceof ApiError ? err.message : "Verification failed");
      });
  }, [token, navigate]);

  return (
    <div className="login-shell">
      <div className="login-card">
        <h1>chatter</h1>
        {status === "checking" && <p>Verifying your email…</p>}
        {status === "ok" && <p>Email verified — signing you in…</p>}
        {status === "error" && (
          <>
            <div className="login-error">{error}</div>
            <div className="login-footer-links">
              <Link to="/login">Back to sign in</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
